import { render, staticRenderFns } from "./Comprovantes.vue?vue&type=template&id=4f161a26&scoped=true&"
import script from "./Comprovantes.vue?vue&type=script&lang=js&"
export * from "./Comprovantes.vue?vue&type=script&lang=js&"
import style0 from "./Comprovantes.vue?vue&type=style&index=0&id=4f161a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f161a26",
  null
  
)

export default component.exports